import { render, staticRenderFns } from "./ConfirmacaoRestricao.vue?vue&type=template&id=36a90075&"
import script from "./ConfirmacaoRestricao.vue?vue&type=script&lang=js&"
export * from "./ConfirmacaoRestricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports